import { useQuery } from '@tanstack/react-query';
import apiClient from 'api/apiConfig';

export interface StoppedByUser {
  userEmail: string;
  userId: string | number;
}

const getAllStoppedByUrl = 'csb/users/all-stopped-by';

export const useGetAllStoppedBy = () => {
  return useQuery<StoppedByUser[]>({
    queryFn: async () => {
      const response = await apiClient.get<StoppedByUser[]>(getAllStoppedByUrl);
      return response.data;
    },
    queryKey: ['allStoppedBy'],
  });
};
